var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/well-known-symbol-wrapped.js
// module id = 286
// module chunks = 0